import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { appConstants } from '../shared';
import { ITenantList } from '../interfaces/tenant.interface';

@Injectable()
export class DashboardManagerService {
  loading: boolean;
  constructor(
    private http: HttpClient
  ) {
  }

  getTenantsList() {
    return this.http.get(appConstants.urls.getTenantsList)
      .pipe(
        map((response: any) => ({
          data: response,
          total: response.length
        }))
      );

    // return of({ "data": { "tenant": [{ "tenantid": "d02f9fd3-1cef-475f-afd3-9918ffc45529", "name": "Bulk User Tenant", "description": "Bulk User Tenants", "organization": "Bulk User Tenant", "businessUnit": "Bulk User Tenant" }, { "tenantid": "de53fead-2c3a-467b-9a98-c855f5e927ef", "name": "CandyStore.com", "description": "Tenant", "organization": "CandyStore.com", "businessUnit": "The Candy Store" }, { "tenantid": "453f6b81-bde9-4e54-9c85-f6ee937881e3", "name": "Continental Dev", "description": "Tenant for SWP Dev env", "organization": "Continental", "businessUnit": "Dev" }, { "tenantid": "b86597bd-7846-48fc-b8ba-3d8baa86ee93", "name": "FSOx - Local", "description": "", "organization": "Omnia", "businessUnit": "FSOx" }, { "tenantid": "a35fe296-a826-4405-bd19-67202abe6544", "name": "Kroger", "description": "", "organization": "Kroger", "businessUnit": "HR" }, { "tenantid": "98d04158-8e90-4b98-b6fd-4ef9e3473469", "name": "Mercedes", "description": "", "organization": "Mercedes", "businessUnit": "Admin" }, { "tenantid": "3e267712-47d2-4282-a491-2a1076479fc7", "name": "pas-platform", "description": "PAS products ", "organization": "BCG Omnia", "businessUnit": "PA Services" }, { "tenantid": "a7ada127-bd8f-4dab-b637-94952998e145", "name": "Relay BCG tenant", "description": "", "organization": "Test", "businessUnit": "Tesnant" }, { "tenantid": "47c04a25-e457-443e-b3df-c9cce9026a5d", "name": "Sprint Demo Tenant", "description": "For Bulk Ops Job Demo", "organization": "Omnia", "businessUnit": "Platform" }, { "tenantid": "68bacbdc-faaa-4ff9-80d4-255f8e63119f", "name": "Stratus BCG", "description": "stratus-tenant", "organization": "BCG", "businessUnit": "OMNIA" }, { "tenantid": "772ecc9f-6a94-4e41-8ad7-2c011d1bcb9a", "name": "Test RelayChange", "description": "Description fields", "organization": "Test", "businessUnit": "Test" }, { "tenantid": "8908b189-1e81-47f9-90cd-29ee58094709", "name": "Volkswagen HR", "description": null, "organization": "Volkswagen Gmbh", "businessUnit": "Human Resources" }, { "tenantid": "46b8f758-912a-4aac-839a-51e556427b15", "name": "volkswagon", "description": "", "organization": "VW", "businessUnit": "Admin" }] }, "message": "tenant fetched sucessfully" })
    //   .pipe(
    //     map((response: any) => ({
    //       data: response.data.tenant,
    //       total: response.data.tenant.length
    //     }))
    //   )
  }

  editTenant(obj: ITenantList) {
    return this.http.put(appConstants.urls.editTenant, obj);
  }

  createTenant(obj: ITenantList) {
    return this.http.post(appConstants.urls.createTenant, obj);
  }

  deleteTenant(tenantId: string) {
    return this.http.delete(appConstants.urls.deleteTenant + '?tenantId=' + tenantId);
  }
}
